module.exports = __webpack_public_path__ + "02_glasses_blue.2750ecdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer4/02_glasses_blue.png
// module id = GxmO
// module chunks = 0